import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addMood, assignMood, getProductMoods, getMoods, resetAssignSuccess, resetAddMood, deleteMood } from 'actions/EntityActions';
import TextInput from 'screens/components/basic/TextInput';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import '../Styles/MoodTerpene.css';

class ProductMood extends Component {
    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        this.props.productId ? this.props.getProductMoods(this.props.productId) : alert("Unable to retrieve Moods");
        this.props.getMoods();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.assignSuccess != null && newProps.assignSuccess != undefined && newProps.assignSuccess != this.props.assignSuccess && newProps.assignSuccess) {
            this.props.productId ? this.props.getProductMoods(this.props.productId) : alert("Unable to retrieve Moods");
            this.props.resetAssignSuccess();
        }
        if (newProps.addSuccess != null && newProps.addSuccess != undefined && newProps.addSuccess != this.props.addSuccess && newProps.addSuccess) {
            this.props.getMoods();
            this.props.resetAddMood();
        }
    }

    addMood = () => {
        let moodName = this.props.addMoodName;
        let validMood = new RegExp('^[A-Za-z]+$');
        if (moodName && !validMood.test(moodName)) {
            alert("Mood Name cannot contain numbers or symbols");
            return;
        }
        this.props.addMood(moodName, this.props.branchId);
    }

    addProductMood = (moodId) => {
        if (!moodId === parseInt(moodId) || !(this.props.productId)) {
            alert("Unable to assign mood to product");
            return;
        }
        this.props.assignMood(this.props.productId, moodId, this.props.branchId);
    }

    deleteProductMood = (moodId) => {
        if (!moodId === parseInt(moodId) || !(this.props.productId)) {
            alert("Unable to un-assign Mood");
            return;
        }
        this.props.deleteMood(this.props.productId, moodId);
    }

    render() {
        const p = this.props;
        let moods = this.props.moods;
        return (
            <React.Fragment>
                <div className="row">
                    {/* LEFT PANEL */}
                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pt-0">
                        <TextInput
                            name={`ProductMoodAddMoodName`}
                            fullWidth={true}
                            label={"Mood Name"}
                            floatingLabelText={"Mood Name"}
                            hintText={"Mood Name"}
                            className="pb-0 mb-0"
                            required />
                        <Button
                            type="AddButton"
                            label="SAVE NEW MOOD"
                            primary={true}
                            onTouchTap={() => this.addMood()} />
                       {
                            !moods || moods.length == 0 ? <h4>No Moods created</h4> :
                                moods.map((item) => {
                                    return (
                                        <h6 className="moodListItem"><span>{item.name}</span> <Button style={{minWidth: `25px`, height: `25px` }} type="IconAdd" onTouchTap={() => this.addProductMood(item.id)} /></h6>
                                    )
                                })
                        }
                    </div>
                    {/* RIGHT PANEL */}
                    <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                        <h5>{p.propProductName ? p.propProductName : p.productName}</h5>
                        <h6 className="pb-2">{p.propProductSKU ? p.propProductSKU : p.productSKU}</h6>
                        <h6><u>Assigned Moods</u></h6>
                        {
                            !p.productMoods || p.productMoods.length == 0 ? <h4>No Moods assigned</h4> :
                                p.productMoods.map((item) => {
                                    return (
                                        <h6 className="moodListItem"><span>{item.name}</span> <Button style={{minWidth: `25px`, height: `25px`}} type="IconDeleteButton" onTouchTap={() => this.deleteProductMood(item.id)} /></h6>
                                    )
                                })
                        }
                    </div>
                </div>
                <div>
                    <Button
                        name="DoneButton"
                        className="pull-right mt-2"
                        label="DONE"
                        primary={true}
                        onTouchTap={() => this.props.onCancel()} />
                </div>
            </React.Fragment>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        addMoodName: state.form["ProductMoodAddMoodName"],
        branchId: state.common.branchId,
        moods: state.entity.moods,
        productMoods: state.entity.productMoods,
        assignSuccess: state.entity.moodsSuccess || false,
        addSuccess: state.entity.addMoodSuccess || false,
        productName: state.form[props.pageName + "Name"] || "Unable to retrieve Product Name",
        productSKU: state.form[props.pageName + "SKU"] || ""
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        addMood: (name, branchId) => dispatch(addMood(name, branchId)),
        assignMood: (productId, moodId, branchId) => dispatch(assignMood(productId, moodId, branchId)),
        getProductMoods: (productId) => dispatch(getProductMoods(productId)),
        getMoods: () => dispatch(getMoods()),
        resetAssignSuccess: () => dispatch(resetAssignSuccess()),
        deleteMood: (productId, moodId) => dispatch(deleteMood(productId, moodId)),
        resetAddMood: () => dispatch(resetAddMood())
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(ProductMood);
